import { gql } from '@apollo/client';
import {
  FormatSettingConfigFragment,
  PermissionFragment,
  RoleWithPermissionsFieldsFragment,
  RoleMetaFieldsFragment,
  UserGroupFragment,
  UserPermissionFragment,
  UserTableFieldsFragment,
  AdminNotificationsFragment,
} from './fragments';
import { UserFragment } from '../fragments';

export const GET_SINGLE_USER_PERMISSION = gql`
  query UserPermission($id: ID!) {
    user(id: $id) {
      ...UserPermissionFields
    }
  }
  ${UserPermissionFragment}
`;

export const GET_USER_GROUPS = gql`
  query UserGroups(
    $term: String
    $type: UserGroupType
    $includeDisabled: Boolean!
    $includes: [ID!]!
    $pagination: Pagination!
  ) {
    userGroups(
      term: $term
      type: $type
      includeDisabled: $includeDisabled
      includes: $includes
      pagination: $pagination
    ) {
      entities {
        ...UserGroupFields
      }
    }
  }
  ${UserGroupFragment}
`;

export const GET_SINGLE_USER_GROUP_PERMISSION = gql`
  query UserGroupPermission($id: ID!) {
    userGroup(id: $id) {
      ...UserGroupFields
    }
  }
  ${UserGroupFragment}
`;

export const GET_PERMISSIONS = gql`
  query Permissions($pagination: Pagination!) {
    permissions(pagination: $pagination) {
      entities {
        ...PermissionFields
      }
    }
  }
  ${PermissionFragment}
`;

export const GET_ROLES = gql`
  query Roles(
    $term: String
    $includeDisabled: Boolean!
    $includes: [ID!]!
    $pagination: Pagination!
  ) {
    roles(
      term: $term
      includeDisabled: $includeDisabled
      includes: $includes
      pagination: $pagination
    ) {
      entities {
        ...RoleMetaFields
      }
    }
  }
  ${RoleMetaFieldsFragment}
`;

export const GET_ROLES_WITH_PERMISSIONS = gql`
  query RolesWithPermissions(
    $term: String
    $includeDisabled: Boolean!
    $includes: [ID!]!
    $pagination: Pagination!
  ) {
    roles(
      term: $term
      includeDisabled: $includeDisabled
      includes: $includes
      pagination: $pagination
    ) {
      entities {
        ...RoleWithPermissionsFields
      }
    }
  }
  ${RoleWithPermissionsFieldsFragment}
`;

export const GET_SINGLE_ROLE_PERMISSION = gql`
  query RolePermission($id: ID!) {
    role(id: $id) {
      ...RoleWithPermissionsFields
    }
  }
  ${RoleWithPermissionsFieldsFragment}
`;

export const GET_USERS_TABLE = gql`
  query UsersTable(
    $term: String
    $includes: [ID!]!
    $pagination: Pagination!
    $userStates: [UserState!]
  ) {
    users(
      term: $term
      includes: $includes
      pagination: $pagination
      userStates: $userStates
    ) {
      entities {
        ...UserTableFields
      }
    }
  }
  ${UserTableFieldsFragment}
`;

export const GET_USERS_WITH_BASIC_INFO = gql`
  query UsersWithBasicInfo(
    $term: String
    $includes: [ID!]!
    $pagination: Pagination!
    $userStates: [UserState!]
  ) {
    users(
      term: $term
      includes: $includes
      pagination: $pagination
      userStates: $userStates
    ) {
      entities {
        ...UserFields
      }
    }
  }
  ${UserFragment}
`;

export const GET_DEFAULT_ROLE = gql`
  query DefaultRole {
    defaultRole {
      id
      name
    }
  }
`;

export const GET_ROLE_PERMISSION_AND_ALL_PERMISSIONS = gql`
  query RolePermissionAndAllPermissions($id: ID!, $pagination: Pagination!) {
    role(id: $id) {
      ...RoleWithPermissionsFields
    }
    permissions(pagination: $pagination) {
      entities {
        ...PermissionFields
      }
    }
  }
  ${RoleWithPermissionsFieldsFragment}
  ${PermissionFragment}
`;

export const GET_FORMAT_SETTING_CONFIG = gql`
  query FormatSettingConfig {
    formatSettingConfig {
      ...FormatSettingConfigFields
    }
  }
  ${FormatSettingConfigFragment}
`;

export const GET_ADMIN_NOTIFICATIONS = gql`
  query AdminNotificationSettings {
    adminNotificationSettings {
      ...AdminNotificationSettingsFields
    }
  }
  ${AdminNotificationsFragment}
`;
